import {
  Alert,
  Button,
  Dialog,
  Portal,
  Stack,
  Text,
} from '@chakra-ui/react';
import { FC } from 'react';
import { Collaborator } from '../types';

type RemoveCollaboratorDialogProps = {
  collaborator: Collaborator | null;
  isRemoving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const RemoveCollaboratorDialog: FC<RemoveCollaboratorDialogProps> = ({
  collaborator,
  isRemoving,
  onCancel,
  onConfirm,
}) => (
  <Dialog.Root
    open={Boolean(collaborator)}
    onOpenChange={({ open }) => {
      if (!open) {
        onCancel();
      }
    }}
  >
    <Portal>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content maxW="md">
          <Dialog.CloseTrigger disabled={isRemoving} />
          <Dialog.Header gap="1" flexDirection={'column'}>
            <Dialog.Title>Remove collaborator</Dialog.Title>
            <Dialog.Description>
              This collaborator will lose access to the project immediately.
            </Dialog.Description>
          </Dialog.Header>
          <Dialog.Body>
            <Stack gap="3">
              <Text>
                Are you sure you want to remove{' '}
                <Text as="span" fontWeight="semibold">
                  {collaborator?.team
                    ? collaborator.team.name
                    : collaborator?.user?.name ??
                      collaborator?.user?.email ??
                      'this collaborator'}
                </Text>{' '}
                from the project?
              </Text>
              <Alert.Root status="warning" variant="subtle">
                <Alert.Indicator />
                <Alert.Content>
                  <Alert.Title>Heads up</Alert.Title>
                  <Alert.Description>
                    They will need to be re-invited to regain access.
                  </Alert.Description>
                </Alert.Content>
              </Alert.Root>
            </Stack>
          </Dialog.Body>
          <Dialog.Footer justifyContent="flex-end" gap="3">
            <Button
              variant="ghost"
              onClick={onCancel}
              disabled={isRemoving}
            >
              Cancel
            </Button>
            <Button
              colorPalette="red"
              onClick={onConfirm}
              loading={isRemoving}
            >
              Remove collaborator
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Portal>
  </Dialog.Root>
);

export default RemoveCollaboratorDialog;
